import { render, staticRenderFns } from "./course-information.vue?vue&type=template&id=6e8a8358&scoped=true&"
import script from "./course-information.vue?vue&type=script&lang=js&"
export * from "./course-information.vue?vue&type=script&lang=js&"
import style0 from "./course-information.vue?vue&type=style&index=0&id=6e8a8358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a8358",
  null
  
)

export default component.exports